import { cn } from "../lib/utils";

const FAMILY_CLASS = {
  UPLD: "det-UPLD",
  MAUP: "det-MAUP",
  SPUP: "det-SPUP",
  WTLD: "det-WTLD",
  MWET: "det-MWET",
  SPWT: "det-SPWT",
  NDSP: "det-NDSP",
  NTST: "det-NTST",
  DITCH: "det-DITCH",
};

export default function DeterminationBadge({ code, label, className }) {
  const cls = FAMILY_CLASS[code] || "det-default";
  return (
    <span
      data-testid={`determination-badge-${code || "unknown"}`}
      className={cn(
        "inline-flex items-center gap-2 px-3 py-1 rounded-full border text-xs font-medium uppercase tracking-[0.12em]",
        cls,
        className,
      )}
    >
      <span className="font-semibold">{code || "—"}</span>
      {label && <span className="normal-case tracking-normal text-[11px] opacity-80">{label}</span>}
    </span>
  );
}
